export default __webpack_public_path__ + "static/media/IMG_5542.594342a1.jpg";